module.exports = __webpack_public_path__ + "static/img/3.3f0834c9.png";